import { render } from "./LeaderboardBox.vue?vue&type=template&id=cd1d412e"
import script from "./LeaderboardBox.vue?vue&type=script&lang=js"
export * from "./LeaderboardBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__